module.exports = __webpack_public_path__ + "static/02-f1031da0f029a4ab6056340d83891236.jpg";